<script lang="ts">
  // The ordinary cart decision, taken from inside a card instead of from a cart bubble.
  // Same endpoint, same result, same event in the thread.
  //
  // If this screen cannot see the cart the control names, the buttons stay dead. A cart
  // the buyer cannot see the current state of is not one to act on, and guessing which
  // cart was meant is exactly the kind of helpfulness that gets someone billed.

  import { t } from '$lib/i18n/index.svelte';

  import type { ElementContext } from '../context';

  let { ctx, cartId }: { ctx: ElementContext; cartId: string | undefined } = $props();

  const cart = $derived(cartId === undefined ? undefined : ctx.resolveCart(cartId));
  const stale = $derived(
    cartId === undefined || ctx.staleCarts.has(cartId) || cart?.state === 'superseded',
  );
  const live = $derived(
    cart !== undefined && !stale && !ctx.disabled && cart.state === 'proposed',
  );

  function decide(decision: 'accept' | 'decline'): void {
    if (cart === undefined || !live) {
      return;
    }
    ctx.onCartRespond(
      cart.cartId,
      decision,
      cart.items.map((item) => ({ itemId: item.itemId, quantity: item.quantity })),
      undefined,
    );
  }
</script>

<span class="pair">
  <button type="button" class="accept" disabled={!live} onclick={() => decide('accept')}>
    {t('views.control.cartAccept')}
  </button>
  <button type="button" class="decline" disabled={!live} onclick={() => decide('decline')}>
    {t('views.control.cartDecline')}
  </button>
</span>

<style>
  .pair {
    display: inline-flex;
    gap: 8px;
  }
  button {
    border: 1px solid var(--line);
    border-radius: 10px;
    background: var(--surface);
    color: var(--ink);
    font: inherit;
    padding: 9px 14px;
    cursor: pointer;
  }
  .accept {
    font-weight: 600;
  }
  button:disabled {
    opacity: 0.5;
    cursor: default;
  }
</style>
